// [2026-08-27] ADDED — entry point for the staff dashboard.
//
// Mirrors the customer app's entry, including the stylesheet ORDER, which is load-bearing:
// shadcn.css reads theme.css's variables (--page, --ink, --series-1) to map shadcn's token names
// onto the palette already validated for contrast and colour-blind separation. Importing it first
// leaves those variables undefined and the sign-in screen renders with unresolved colours.
//
// Both stylesheets come from the client package — there is exactly one copy of this design system
// and both apps use it. Do not fork them.
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@incruiter/proctoring-client-frontend/theme.css'
import '@incruiter/proctoring-client-frontend/shadcn.css'
// [2026-09-07] ADDED — the staff dashboard's skin, so it looks like the customer dashboard.
//
// THIRD, AND THAT IS DELIBERATE. It redefines tokens theme.css sets on :root (--page, --ink,
// --border, --font, --radius) and restyles classes theme.css defines (.btn, thead th, .sidebar),
// so it has to be LAST — it wins by source order, not by specificity, the same rule the two lines
// above already follow.
//
// It does not disturb shadcn.css above it. Custom properties resolve where they are USED, not
// where they are declared, so shadcn's var(--page) picks up the new value even though shadcn was
// parsed first. Nothing about that ordering changes.
//
// ⚠️ ONLY THIS APP MAY IMPORT IT. :root is global — there is no scoping that would keep these
// tokens off the customer screens if the customer app ever imported it. That app gets its look
// from platform-theme.css instead. See the header of platform-admin.css.
//
// It is NOT a fork of theme.css (which the rules in CLAUDE.md forbid, rightly): theme.css is
// untouched and still shared by both apps. This is an override layer that one app loads.
import '@incruiter/proctoring-client-frontend/platform-admin.css'
// [2026-09-02] CHANGED — this build now boots the SDK-backend staff dashboard.
//
// WHY: ./App.jsx renders the client package's shell plus five screens written against the OLD
// proctoring-backend gateway (port 8011), which the team has stopped running — so this app was
// pointing at a service that is not there. ./sdk/AdminApp.jsx is a self-contained shell for
// proctoring-sdk-backend's /admin/v1, which is the live one.
//
// NOTHING WAS DELETED. ./App.jsx and its three views (Admin.jsx, AdminHealth.jsx, AdminKeys.jsx)
// are untouched on disk and still compile; restoring the old entry is a one-line revert of the
// import below. They are the only record of those API shapes.
//
// OLD: import AdminApp from './App.jsx'
import AdminApp from './sdk/AdminApp.jsx'

// NOTE: the customer entry additionally awaits redeemHandoff() before rendering, so a user arriving
// from InCruiter with a handoff code does not see a flash of the sign-in screen. That flow is for
// CUSTOMERS arriving from the InCruiter product; an InCruiter operator signs in at this app's own
// door, so there is no handoff code to redeem and nothing to wait for.
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AdminApp />
  </StrictMode>,
)
